import NoMatchRoute from './NoMatchRoute';

export default NoMatchRoute;
